import { MutationConfig, QueryConfig, useMutation, useQuery } from 'react-query';

import { GetCheckoutData, GetPrducerCheckoutDetailsResponse, UpdateCheckout } from './producer-checkout.types';

export const updateProducerPaymentDetails = ({ client, body, paymentId }: UpdateCheckout) =>
  client.patch(`/producer/payment/${paymentId}`, body).then(({ data }) => data);

export const useUpdatePaymentDetails = (
  options?: MutationConfig<GetPrducerCheckoutDetailsResponse, Record<'data', Record<'stack' | 'message', ''>>>,
) => useMutation(updateProducerPaymentDetails, options);

const getPrducerCheckoutDetails = ({ client, paymentId }: GetCheckoutData) =>
  client.get<GetPrducerCheckoutDetailsResponse>(`/producer/payment/${paymentId}`).then(({ data }) => data);

export const useGetPrducerCheckoutDetails = ({
  client,
  paymentId,
  options,
}: GetCheckoutData & {
  options?: QueryConfig<GetPrducerCheckoutDetailsResponse, unknown> | undefined;
}) =>
  useQuery(['getPrducerCheckoutDetails', paymentId], () => getPrducerCheckoutDetails({ client, paymentId }), {
    ...options,
  });